export const billingCountryOptions = [
  ["AD", "Andorra"],
  ["AG", "Antigua and Barbuda"],
  ["AL", "Albania"],
  ["AR", "Argentina"],
  ["AT", "Austria"],
  ["BA", "Bosnia and Herzegovina"],
  ["BB", "Barbados"],
  ["BE", "Belgium"],
  ["BG", "Bulgaria"],
  ["BO", "Bolivia"],
  ["BR", "Brazil"],
  ["BS", "Bahamas"],
  ["BY", "Belarus"],
  ["BZ", "Belize"],
  ["CA", "Canada"],
  ["CH", "Switzerland"],
  ["CL", "Chile"],
  ["CO", "Colombia"],
  ["CR", "Costa Rica"],
  ["CU", "Cuba"],
  ["CY", "Cyprus"],
  ["CZ", "Czechia"],
  ["DE", "Germany"],
  ["DK", "Denmark"],
  ["DM", "Dominica"],
  ["DO", "Dominican Republic"],
  ["EC", "Ecuador"],
  ["EE", "Estonia"],
  ["ES", "Spain"],
  ["FI", "Finland"],
  ["FR", "France"],
  ["GB", "United Kingdom"],
  ["GD", "Grenada"],
  ["GR", "Greece"],
  ["GT", "Guatemala"],
  ["GY", "Guyana"],
  ["HN", "Honduras"],
  ["HR", "Croatia"],
  ["HT", "Haiti"],
  ["HU", "Hungary"],
  ["IE", "Ireland"],
  ["IS", "Iceland"],
  ["IT", "Italy"],
  ["JM", "Jamaica"],
  ["KN", "Saint Kitts and Nevis"],
  ["LC", "Saint Lucia"],
  ["LI", "Liechtenstein"],
  ["LT", "Lithuania"],
  ["LU", "Luxembourg"],
  ["LV", "Latvia"],
  ["MD", "Moldova"],
  ["MC", "Monaco"],
  ["ME", "Montenegro"],
  ["MK", "North Macedonia"],
  ["MT", "Malta"],
  ["MX", "Mexico"],
  ["NI", "Nicaragua"],
  ["NL", "Netherlands"],
  ["NO", "Norway"],
  ["PA", "Panama"],
  ["PE", "Peru"],
  ["PL", "Poland"],
  ["PY", "Paraguay"],
  ["PT", "Portugal"],
  ["RO", "Romania"],
  ["RS", "Serbia"],
  ["RU", "Russia"],
  ["SM", "San Marino"],
  ["SE", "Sweden"],
  ["SI", "Slovenia"],
  ["SK", "Slovakia"],
  ["SR", "Suriname"],
  ["SV", "El Salvador"],
  ["TT", "Trinidad and Tobago"],
  ["UA", "Ukraine"],
  ["US", "United States"],
  ["UY", "Uruguay"],
  ["VA", "Vatican City"],
  ["VC", "Saint Vincent and the Grenadines"],
  ["VE", "Venezuela"],
  ["XK", "Kosovo"],
] as const satisfies ReadonlyArray<readonly [string, string]>;

export const billingCountries = billingCountryOptions.map(([value, label]) => ({
  value,
  label,
}));
